<template>
  <div class="d-flex data-entry flex-column flex-grow-1">
    <resize-observer @notify="setScrollbarHeight"/>
    <perfect-scrollbar id="container-scroll" :style="{height: scrollbarHeight}">
      <div class="approval conference-card">
        <div class="card-header">
          <div class="row">
            <div class="col">
              <h2 class="mt-3 mb-0 conference-header-title">
                <slot name="title"></slot>
              </h2>
            </div>
          </div>
        </div>
        <div class="card-body">
          <ifac-loader
            v-if="isLoading"
            :style="{height: `${mx_loaderHeight}px`}"
          />
          <div class="mt-2">
            <slot></slot>
          </div>
        </div>
        <slot name="before-footer"></slot>
        <main-footer ref="footer"></main-footer>
      </div>
    </perfect-scrollbar>
  </div>
</template>
<script>
import { IfacLoader, ifacUiMixin } from '@ifac/ui';
import MainFooter from '@/views/layouts/MainFooter.vue';

export default {
  name: 'LeftSide',
  mixins: [ifacUiMixin],
  components: { MainFooter, IfacLoader },
  props: {
    isLoading: Boolean,
  },
  data() {
    return {
      scrollbarHeight: 0,
      mx_loaderHeight: 110,
    };
  },
  mounted() {
    this.setScrollbarHeight();
  },
  methods: {
    setScrollbarHeight() {
      this.scrollbarHeight = `calc(100vh - ${this.mx_upperZoneHeight}px)`;
    },
  },
};
</script>

<style scoped lang='scss'>
@import '@/assets/styles/base/_variables.scss';
@import '@/assets/styles/base/_mixins.scss';
</style>
